// extracted by mini-css-extract-plugin
export default {"root":"XHOQ12V6pZG9NZmhmsjp"};